<h2 mat-dialog-title class="dialog-header">
  <span class="title-large">{{ 'orders.ui.selezionaCodiceCliente' | transloco }}</span>

  <button mat-icon-button type="button" [attr.aria-label]="'orders.ui.chiudi' | transloco" (click)="onCancel()">
    <i class="fa-regular fa-xmark"></i>
  </button>
</h2>

<mat-dialog-content class="content">
  @if (data.oil.length) {
    <section class="code-group">
      <span class="label-large-emphasized">{{ 'orders.ui.codiceOil' | transloco }}</span>
      <div class="code-options" role="radiogroup" [attr.aria-label]="'orders.ui.codiceOil' | transloco">
        @for (item of data.oil; track item.codice) {
          <button
            type="button"
            role="radio"
            class="code-card"
            [class.selected]="oilCode === item.codice"
            [attr.aria-checked]="oilCode === item.codice"
            [disabled]="data.oil.length === 1"
            (click)="oilCode = item.codice"
          >
            <span class="body-medium-emphasized">{{ item.codice }}</span>
            <span class="body-medium">{{ data.ragioneSociale }}</span>
            <span class="body-small">{{ item.zona }}</span>
            @if (data.oil.length === 1) {
              <span class="body-small">{{ 'orders.ui.assegnatoAutomaticamente' | transloco }}</span>
            } @else if (isLastUsed(item.codice)) {
              <span class="body-small">{{ 'orders.ui.ultimoCodiceUtilizzato' | transloco }}</span>
            }
          </button>
        }
      </div>
    </section>
  }

  @if (data.nonOil.length) {
    <section class="code-group">
      <span class="label-large-emphasized">{{ 'orders.ui.codiceNonOil' | transloco }}</span>
      <div class="code-options" role="radiogroup" [attr.aria-label]="'orders.ui.codiceNonOil' | transloco">
        @for (item of data.nonOil; track item.codice) {
          <button
            type="button"
            role="radio"
            class="code-card"
            [class.selected]="nonOilCode === item.codice"
            [attr.aria-checked]="nonOilCode === item.codice"
            [disabled]="data.nonOil.length === 1"
            (click)="nonOilCode = item.codice"
          >
            <span class="body-medium-emphasized">{{ item.codice }}</span>
            <span class="body-medium">{{ data.ragioneSociale }}</span>
            <span class="body-small">{{ item.zona }}</span>
            @if (data.nonOil.length === 1) {
              <span class="body-small">{{ 'orders.ui.assegnatoAutomaticamente' | transloco }}</span>
            } @else if (isLastUsed(item.codice)) {
              <span class="body-small">{{ 'orders.ui.ultimoCodiceUtilizzato' | transloco }}</span>
            }
          </button>
        }
      </div>
    </section>
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button matButton="filled" type="button" [disabled]="!canConfirm" (click)="onConfirm()">{{ 'orders.ui.conferma' | transloco }}</button>
  <button matButton type="button" (click)="onCancel()">{{ 'orders.ui.annulla' | transloco }}</button>
</mat-dialog-actions>
